import { CustomModalCell } from '../../../components/custom-modal-cell';

export const FORM_NAME = 'company-form';
export const FORM_SETTINGS_NAME = 'company-settings-form';
export const FORM_ABOUT_NAME = 'company-about-form';
export const FORM_SETTINGS_ADMIN_NAME = 'company-admin-settings-form';

export const COMPANIES_FORM_REQUIRED_FIELDS = [
	'delivery_methods',
	'transports',
	'contact.post',
	'contact.last_name',
	'contact.first_name',
	'contact.email',
	'contact.phone',
];

export const COMPANIES_FORM_SERVER_RESPONSE_ERROR = [
	'description',
	'website',
	'delivery_methods',
	'transports',
	'modes',
	'has_validated_transport',
	'has_qms',
	'contact.post',
	'contact.last_name',
	'contact.first_name',
	'contact.email',
	'contact.phone',
	'contact.extension',
];

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const TABLE_COLUMNS_NAMES = [
	{ id: 'title', width: '395px' },
	{ id: 'value', customComponent: CustomModalCell },
];
export const TABLE_SETTINGS_COLUMNS_NAMES = [{ dataIndex: 'label', width: 400 }, { dataIndex: 'value' }];

export const TABLE_ROWS_ABOUT_NAMES = {
	description: 'О компании',
	website: 'Сайт компании',
	delivery_methods: 'Способы доставки',
	transports: 'Автопарк',
	modes: 'Температурные режимы',
	has_validated_transport: 'Есть валидированный транспорт',
	has_qms: 'Наличие СМК',
	contact: 'Контакт для связи',
};

export const TABLE_ROWS_NAMES = {
	type: 'Тип компании',
	inn: 'ИНН',
	ogrn: 'ОГРН',
	address: 'Юридический адрес',
	contact: 'Контакты',
	contract: 'Договор',
	saas: 'Договор SaaS',
	is_accredited: 'Компания аккредитована',
	is_validated: 'Компания прошла аудит',
	has_contract: 'Подписан договор c МАК-Лоджик',
	has_saas: 'Подписан договор SAAS',
};

export const TABLE_TAX_ROWS_NAMES = {
	org_type: 'Тип организации',
	tax_system: 'Система налогообложения',
	tax_rate: 'Налоговая ставка',
};

export const FIELDS_FOR_VALIDATE = [
	'company.type_id',
	'company.inn',
	'company.ogrn',
	'company.address',
	'contact.last_name',
	'contact.first_name',
	'contact.middle_name',
	'contact.email',
	'contact.phone',
	'company.contract_number',
	'company.saas_number',
	'company.is_accredited',
	'company.is_validated',
	'company.has_contract',
	'company.has_saas',
];

export const REQUIRED_FIELDS = [
	'company.name',
	'company.inn',
	'company.ogrn',
	'company.address',
	'contact.last_name',
	'contact.first_name',
	'contact.email',
	'contact.phone',
];

export const FIELDS_FOR_SETTINGS_VALIDATE = ['transports', 'documents[0].key', 'documents[0].name'];
export const FIELDS_FOR_ADMIN_SETTINGS_VALIDATE = ['company.transports', 'company.claims', 'company.my_transports'];

export const REQUIRED_FIELDS_SETTINGS = ['documents'];
export const DOCUMENTS_REQUIRED_FIELDS = ['key', 'name'];
